import { TabContainer, TabContainerProps } from '@collab/molecules';

const Tabs: React.FC<TabContainerProps> = ({ ...props }) => (
  <div className="mt-32">
    <TabContainer {...props} />
  </div>
);

export default Tabs;
